import { NotAuthorizedError } from '@adornis/baseql/errors/NotAuthorizedError.js';
import { hasNexusSchedulingAccess } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { defer, EMPTY, from, type Observable, switchMap } from 'rxjs';

export async function assertNexusSchedulingMutationAllowed(clientId?: string): Promise<void> {
  if (!(await hasNexusSchedulingAccess(clientId))) {
    throw new NotAuthorizedError(NexusPermission.Scheduling, 'workflows-dell scheduling');
  }
}

export function gateNexusSchedulingSubscription<T>(inner: () => Observable<T>): Observable<T> {
  return defer(() => from(hasNexusSchedulingAccess()).pipe(switchMap(allowed => (allowed ? inner() : EMPTY))));
}
